import fetch from "auth/FetchInterceptor";

const TxtFileService = {};
const apiRoute = "/home";

TxtFileService.getTxtFileLinks = async function (query = "") {
  try {
    const res = await fetch({
      url: `${apiRoute}/getTxt/public`,
      method: "get",
    });
    return res;
  } catch (err) {
    console.log(err, "show-err");
  }
};
export default TxtFileService;
